import { gsap } from "gsap";

window.addEventListener("load", () => {
    const heroSection = document.querySelector(".HeroComponent");
    const headerText = document.querySelector<HTMLElement>(".HeaderComponent .profileName");
    const header = document.querySelector(".HeaderComponent");

    if (!heroSection || !headerText) return;

    const headerRect = header.getBoundingClientRect();
    const headerHeight = headerRect.height;

    const observerOptions = {
        rootMargin: `-80px 0px 0px 0px`,
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                gsap.to(headerText, { color: "#2d2d2d", duration: 0.2 });
            } else {
                gsap.to(headerText, { color: "#fdfcfb", duration: 0.2 });
            }
        });
    }, observerOptions);

    observer.observe(heroSection);
});